//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import { date } from "quasar";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import i18n from "@/i18n/index";

import { timelineData } from "./dataTimeline";

export default {
    name: "AQTimeline",
    components: {
        AQChip,
        AQMenu,
        AQDialog,
        AQInput
    },
    props: {
        historyType: { type: String, required: true, default: () => "save" }, /* "save", "change"  */
        timelineList: { type: Array, required: true, default: () => [] }, // timeline items
        activeCommitId: { type: String, default: "" }, // active commit id while preview
        timelineKey: { type: Number, default: 0 }
    },

    data() {
        return {
            // eslint-disable-next-line global-require
            moreIcon: require("@/assets/images/more_vert_24px.svg"),
            publishType: "publish",
            setOfStandaloneTypes: new Set(["publish", "delete", "recover"]),
            showMenu: [],
            defaultType: "edit",
            defaultHistoryType: "save",
            actionDialog: false,
            regexValidationNote: new RegExp(/^[A-Za-z0-9 _.,!"'/$]*[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/),
            hasError: false,
            hasErrorLabel: null,
            confirmLabel: null,
            dialogTitle: null,
            noteObject: {},
            note: null,
            createNote: false
        };
    },
    computed: {
        createNoteDisabled() {
            return !this.note && this.createNote;
        }
    },
    methods: {
        userType(timelineItem) {
            return timelineItem.isUserActive ? "user" : "disabledUser";
        },
        validateNote() {
            this.hasError = !this.regexValidationNote.test(this.note);
        },
        actionNote() {
            this.noteObject.note = this.note;
            this.$emit("actionNote", this.noteObject);
            this.actionDialog = false;
        },
        setDialogDetails(actionName, timelineItem) {
            this.noteObject.timelineItem = timelineItem;
            switch (actionName) {
                case "add":
                    this.dialogTitle = this.$t("versioning.dialogTitleCreate", { date: `${this.dateFormatter(timelineItem.timestamp, true)}` });
                    this.confirmLabel = this.$t("versioning.createNote");
                    this.createNote = true;
                    break;
                case "edit":
                    this.dialogTitle = this.$t("versioning.dialogTitleEdit", { date: `${this.dateFormatter(timelineItem.timestamp, true)}` });
                    this.confirmLabel = this.$t("versioning.updateNote");
                    this.createNote = false;
                    break;
                default:
                    break;
            }
        },
        menuClick(action, timelineItem) {
            if (action && action.name) {
                this.note = timelineItem.note || "";
                if (action.name !== "export" && action.name !== "restore") {
                    this.setDialogDetails(action.name, timelineItem);
                    this.actionDialog = true;
                }
                this.$emit("click", { actionName: action.name, timelineItem });
            }
        },
        menuOptions(hasNote) {
            const name = hasNote ? "edit" : "add";
            const label = hasNote ? `${i18n.t("versioning.editNote")}` : `${i18n.t("versioning.addNote")}`;
            const options = [
                { name, label },
                { name: "restore", label: `${i18n.t("versioning.restore")}` }
            ];
            return options;
        },
        dateFormatter(dateToFormat, showYear) {
            let dateReturn = "";
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(".") : "";
            const data = new Date();
            data.setMonth(newData[1] - 1);
            const year = newData[2].split(" ")[0];
            const hour = newData[2].split(" ")[1].substring(0, 5);
            const withYear = (this.historyType !== this.defaultHistoryType || showYear) ? `, ${year}` : "";
            if (localStorage.getItem("language") === "ro") {
                dateReturn = `${newData[0]} ${data.toLocaleString("ro-RO", { month: "long" })}${withYear} ${i18n.t("versioning.at")} ${hour}`;
            } else {
                dateReturn = `${data.toLocaleString("en-US", { month: "long" })} ${newData[0]}${withYear} ${i18n.t("versioning.at")} ${hour}`;
            }
            return dateReturn;
        },
        itemIcon(itemType) {
            const typeNow = Object.keys(timelineData).includes(itemType) ? itemType : this.defaultType;
            return timelineData[typeNow].icon;
        },
        itemClick(action, timelineItem) {
            if (!action.target.classList.contains("timeline_icon_more")) {
                this.$emit("itemClick", timelineItem);
            }
        },
        isStandaloneType(type) {
            return this.setOfStandaloneTypes.has(type);
        },
        titleText(timelineItem) {
            return this.isStandaloneType(timelineItem.commitType) ? timelineData[timelineItem.commitType].verb : this.dateFormatter(timelineItem.timestamp);
        }
    }
};
